import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import IntlDateTime from 'components/layout/IntlDateTime';

import List from 'components/List';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class FailedRefunds extends React.Component {
  // change the url to display client information
  handleRowClick = detailsUrl => {
    this.props.history.push(detailsUrl);
  };

  getBreadcrumb = () => {
    const messages = this.props.intl.messages;
    return (
      <Breadcrumb
        crumbs={[
          { link: this.props.appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: this.props.appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.failed_refunds },
        ]}
        className="p-t-0"
      />
    );
  };

  render() {
    const { intl, appIntl, list } = this.props;
    const messages = intl.messages;

    const columns = ['ID', messages.date, messages.payment_method, messages.actions];
    let tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const failedRefund = list.data.list[i];
      const { id, payment, cdate } = failedRefund;

      const detailsUrl = appIntl.urlPrefix + 'account/settings/failedRefunds/' + id;

      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(detailsUrl)}>
          <td class="v-align-middle">{id}</td>
          <td class="v-align-middle">
            <IntlDateTime date={cdate} />
          </td>
          <td class="v-align-middle">{payment}</td>
          <td class="v-align-middle text-right">
            <Link to={detailsUrl} class="btn-rounded m-r-10 btn btn-sm btn-default">
              <i class="fa fa-pencil-alt" /> {messages.edit}
            </Link>
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column == messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.failed_refunds)}>
        <List
          listName="failedRefunds"
          url="/api/failedrefunds.json"
          list={this.props.list}
          title={messages.failed_refunds}
          iconClass="fal fa-times-circle"
          showSearch
          sortOptions={['cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
        >
          {resultTable}
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.failedRefunds,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(FailedRefunds)));
